import { getShareBetDataWithKey } from '@core/Areas/ShareBet/helpers/api'
import { loadBet } from '@core/Areas/ShareBet/LoadBet'
import { trackShareBetLinkOpen } from '@core/Areas/ShareBet/helpers/analytics'
import { isKambiSportBetDetails } from '@core/Areas/ShareBet/LoadBet/typeGuards'
import type { QuickbetSelection } from '@core/Areas/Quickbet/types'
import type { LoadBetDetails } from '@core/Areas/ShareBet/LoadBet/types'

export async function buildSharedBetSelections({
  shareId,
}: {
  shareId: string | null
}): Promise<QuickbetSelection[]> {
  if (!shareId) {
    throw new Error('No Share Provided')
  }

  const { data, accountNumber: origin } = await getShareBetDataWithKey(shareId)

  const { selections } = await loadBet(data, { location: 'share-bet', origin })

  trackShareBetLinkOpen({
    share_origin: origin,
    betType: getBetTypeForLinkOpenTracking(data),
  })

  return selections
}

// =============
// Local Helpers
// =============

function getBetTypeForLinkOpenTracking(data: LoadBetDetails[]): string {
  if (data.length > 0 && isKambiSportBetDetails(data[0])) {
    const betType = data[0].betSelectionType
    if (betType === 'same-game-multi') return betType
    return `sports-${betType}`
  }

  return data.length === 1 ? 'single' : 'multi'
}
